import { useAuth } from 'react-oidc-context';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const auth = useAuth();

    return auth.isAuthenticated && !auth.isLoading ? children : null;
};

export default ProtectedRoute;
